<template>
  <MultiSelectDefault
    :facet="facet"
    :custom-value-renderer="customValueRenderer"
  />
</template>

<script setup>
import { h } from 'vue';
import Reviewlet from '@atomic-ui/reviewlet';
import MultiSelectDefault from './MultiSelectDefault';

defineProps({
  facet: {
    type: Object,
    required: true,
  },
});

function customValueRenderer(value) {
  if (value.count) {
    return {
      label: h(Reviewlet, {
        size: 'large', rating: parseInt(value.value[0], 10), 'show-review-text': false, 'show-rating': false,
      }),
      ariaLabel: value.label,
      value: value.value,
      count: value.count,
      labelType: 'html',
    };
  }
  return '';
}

</script>

<style scoped lang="scss">
  :deep(.rating) {
    margin-top: 0;
  }

  :deep(.valueLabel) {
    display: flex;
    align-items: center;
  }
</style>
